import * as yup from 'yup';

export const eventFormSchema = yup.object({
  status: yup
    .mixed<'DRAFT' | 'PUBLISHED'>()
    .oneOf(['DRAFT', 'PUBLISHED'])
    .default('DRAFT')
    .required(),
  label: yup
    .string()
    .required('Le label est obligatoire')
    .max(200, 'Le label ne peut pas dépasser 200 caractères'),
  eventTypeId: yup
    .string()
    .uuid()
    .required("Le type d'événement est obligatoire"),
  eventDate: yup.date().required("La date de l'événement est obligatoire"),
  description: yup.string().when('status', {
    is: 'PUBLISHED',
    then: (schema) =>
      schema.required('La description est obligatoire pour publier'),
  }),
  clientName: yup
    .string()
    .nullable()
    .when('status', {
      is: 'PUBLISHED',
      then: (schema) =>
        schema.required('Le client est obligatoire pour publier'),
    }),
  serviceName: yup
    .string()
    .nullable()
    .when('status', {
      is: 'PUBLISHED',
      then: (schema) =>
        schema.required('Le service est obligatoire pour publier'),
    }),
  kpiIds: yup
    .array(yup.string().uuid())
    .default([])
    .when('status', {
      is: 'PUBLISHED',
      then: (schema) => schema.min(1, 'Au moins un KPI doit être sélectionné'),
    }),
  revenue: yup
    .number()
    .nullable()
    .min(0, 'Le revenu ne peut pas être négatif')
    .optional(),
  externalAffairId: yup
    .string()
    .max(100, "L'affaire externe ne peut pas dépasser 100 caractères")
    .optional(),
  externalNeedId: yup
    .string()
    .max(100, 'Le besoin externe ne peut pas dépasser 100 caractères')
    .optional(),
  externalContactId: yup
    .string()
    .max(100, 'Le contact externe ne peut pas dépasser 100 caractères')
    .optional(),
  parentEventId: yup.string().uuid().nullable().optional(),
});

export type EventFormValues = yup.InferType<typeof eventFormSchema>;
